<form [formGroup]="authnForm">
    <div class = "inline-container">
          <div class = "text-center">
           <input type="hidden" id="{{id}}" [name]="name" formControlName="hiddenControl"
           [defaultValue]="callback?.getInputValue()"
           (change)="updateValue($event)" >
          </div>
      </div>
    </form>
  